import type { ChatOverview } from '@/types/teacher-chat'
import { formatTime } from '@/utils/chatHelpers'
import { AvatarStack } from './AvatarStack'

interface ChatItemProps {
  chat: ChatOverview
  isSelected: boolean
  onSelect: () => void
}

export function ChatItem({ chat, isSelected, onSelect }: ChatItemProps) {
  const label = chat.participants.length > 2
    ? `${chat.participants.length} Teilnehmer`
    : (chat.participants.find(p => !p.is_current_user)?.teacher_name || chat.participants[0]?.teacher_name || 'Chat')

  const unreadText = chat.unread_count > 0 ? `, ${chat.unread_count} ungelesene Nachrichten` : ''
  const ariaLabel = `Chat mit ${label}${unreadText}`

  return (
    <div
      className={`${isSelected ? 'chat-item-active' : 'hover:bg-gray-50'} px-3 py-2.5 cursor-pointer border-l-2 ${isSelected ? 'border-blue-400' : 'border-transparent'}`}
      onClick={onSelect}
      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect() } }}
      role="button"
      tabIndex={0}
      aria-selected={isSelected}
      aria-label={ariaLabel}
    >
      <div className="flex items-center gap-2.5">
        <AvatarStack participants={chat.participants} isActive={isSelected} />
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-baseline">
            <span className="font-semibold text-sm truncate text-gray-900">
              {label}
            </span>
            {chat.last_message && (
              <span className="text-[10px] text-gray-400 shrink-0 ml-1">
                {formatTime(chat.last_message.created_at)}
              </span>
            )}
          </div>
          <div className="text-xs text-gray-400 truncate">
            {chat.last_message ? (
              <>
                <span className="font-medium text-gray-300">
                  {chat.last_message.sender_name}:
                </span>{' '}
                {chat.last_message.body}
              </>
            ) : (
              <span className="italic">Noch keine Nachrichten</span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
